// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

function DocumentChooser({ value }) {
  return (
    <a className="documentChooser--backend" href={value.file} target="_blank" rel="noreferrer">{value.file}</a>
  );
}

DocumentChooser.propTypes = {
  value: PropTypes.shape({
    file: PropTypes.string.isRequired,
  }).isRequired,
};

export default DocumentChooser;
